import { Link, Typography } from "../../../components/util";
import { emails } from "../../../config/appConfig";

const AuthErrorFooter = () => {
  return (
    <Typography variant="body2">
      Please email{" "}
      <Link href={`mailto:${emails.careSupport}`} isNewTab>
        {emails.careSupport}
      </Link>{" "}
      if you feel this is an error.
    </Typography>
  );
};

export default AuthErrorFooter;
